const passengers = {
  passengers: 'Pasajeros',
  passengerTypes: {
    default: 'Predeterminado',
    student: 'Estudiante',
    employee: 'Empleado',
    caregiver: 'Cuidador',
  },
  headerButtons: {
    create: {
      createBtn: 'Crear',
      employee: 'Empleado',
      student: 'Alumno',
    },

    import: 'Importar',
  },

  toast: {
    error: {
      badResponse: '[Pasajero] respuesta incorrecta del servidor',
      create: {},
      edit: {},
    },
    success: {
      resetSuccess: 'El correo electrónico para restablecer la contraseña se ha enviado correctamente.',
      create: {
        default: '[Pasajero] Creado',
      },
      edit: {
        default: '[Pasajero] Actualizado',
      },
      delete: {
        default: '[Pasajero] eliminado correctamente',
      },
    },
    alreadyExistToast: {
      messages: {
        phone: 'El teléfono ya está en uso por otro pasajero',
        email: 'El correo electrónico ya está en uso por otro pasajero',
      },
    },
  },

  deleteModal: {
    header: 'Eliminar pasajeros',
    body: 'Está a punto de eliminar {{num}} pasajeros.',
  },

  create: {
    successToast: {
      message: '¡Éxito! Pasajero creado correctamente',
    },
    errorToast: {
      message: 'Ocurrió un error. ¡No se pudo crear pasajero!',
    },
  },

  update: {
    successToast: {
      message: '¡Éxito! Los pasajeros se actualizan correctamente',
    },
    errorToast: {
      message: 'Ocurrió un error. ¡No se pudo actualizar el pasajero!',
    },
  },

  edit: {
    tabs: {
      information: 'Información general',
      notes: 'Notas',
      history: 'Historia',
      bookingHistory: 'Historial de reservas',
    },
    modalRemoveConfirm: {
      header: '¡Advertencia!',
      body: '¿Está seguro de que desea eliminar este pasajero?',
      modalRemoveConfirmBtnConfirm: 'Eliminar',
    },
    activeStatus: {
      statusActive: 'Activo',
      statusDeactivate: 'Inactiva',
    },
    suspend: {
      actionActivate: 'Reactivar',
      actionDeactivate: 'Suspender',
      suspendModal: {
        popupTitleDeactivation: 'Suspender pasajero',
        popupTitleActive: 'Suspender Motivo',
        popupTitleUnsuspend: 'Motivo de remover suspensión',
        popupSubTitleDeactivation: 'Selecciona el motivo de la suspensión',
        popupActionActive: 'Reactivar pasajero',
        popupActionDeactivate: 'Suspender pasajero',
      },
    },
  },

  table: {
    filters: {
      facility: 'Instalación',
      type: 'Tipo',
      attributes: 'Atributos',
    },
    headers: {
      name: 'Nombre',
      type: 'Tipo',
      email: 'Correo electrónico',
      created: 'Fecha de creación',
      id: 'ID',
      profile: 'Perfil',
      supplier: 'Preferido',
      phone: 'Telefono',
      createdBy: 'Creado por',
      baseAddress: 'Dirección de domicilio',
      occupationAddress: 'Dirección de trabajo',
      attributes: 'Atributos',
    },
    passengersGettExtraHeaders: {
      home: 'Domicilio',
      home2: 'Domicilio2',
      work: 'Trabajo',
      site: 'Sitio',
    },
    empty: 'Vacío',
    actions: {
      delete: 'Eliminar',
      export: 'Exportar',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },

  forms: {
    header: {
      createPassenger: {
        title: 'Crear',
      },

      updatePassenger: {
        title: 'Actualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      profile: {
        header: 'Perfil',
        fields: {
          profile: 'Perfil',
        },
      },
      supplier: {
        header: 'Preferido',
        fields: {
          label: 'Proveedor Preferido',
        },
      },
      attributes: {
        header: 'Atributos',
        fields: {
          label: 'Atributos',
        },
      },
      paymentTypes: {
        header: 'Tipos de pago',
        fields: {
          membership: 'Membresía',
        },
        actions: {
          save: 'Guardar',
        },
      },
      details: {
        header: 'Detalles personales',
        fields: {
          firstName: 'Nombre',
          lastName: 'Apellido',
          email: 'Correo electrónico',
          phone: 'Telefono',
          ada: 'Ada',
          additionalPhone: 'Teléfono adicional',
          code: 'Código',
        },
      },
      address: {
        header: 'Dirección del pasajero',
        sharedValues: {
          manual: 'Dirección manual',
        },
        fields: {
          homeAddress: {
            label: 'Dirección de domicilio',
          },
          homeAddress2: {
            label: 'Dirección de inicio 2',
          },
          officeAddress: {
            label: 'Dirección de trabajo',
          },
          workAddress: {
            label: 'Dirección de trabajo',
          },
        },
      },
      actions: {
        header: 'Acciones',
        buttons: {
          delete: 'Eliminar',
          resetPassword: 'Restablecer contraseña',
        },
      },
      health: {
        header: 'Información de salud',
        fields: {
          certificationDate: 'Fecha de certificación',
          expirationDate: 'Fecha de vencimiento',
          disabilityAidTools: 'Herramientas de ayuda para discapacitados',
        },
      },
      caregiverInfo: {
        header: 'Información del cuidador',
        fields: {
          caregiverFirstName: 'Nombre',
          caregiverLastName: 'Apellido',
          caregiverEmail: 'Correo electrónico',
          caregiverPhone: 'Telefono',
        },
      },
      jobClusters: {
        header: 'Agrupaciones de Reservas',
        fields: {
          limitedMobility: 'Movilidad Reducida',
        },
        information: {
          limitedMobility: 'El sistema ignorará la "Distancia Máxima" y seleccionará el punto de recogida/descenso más cercano a la dirección del pasajero',
        }
      },
    },
    jobHistory: {
      header: 'Historial de reservas',
      popupInfo: {
        date: 'Hora de recogida solicitada: {{time}}',
        header: 'Información de reserva',
        from: 'De:',
        to: 'Hacia:'
      }
    },

    validations: {
      firstName: 'El nombre es obligatorio',
      lastName: 'Apellido es obligatorio',
      profiles: 'Los perfiles son obligatorios',
      email: {
        required: 'El correo electrónico es obligatorio',
        email: 'Dirección de correo electrónico no válida',
      },
      unit: {
        required: 'El sitio es obligatorio',
      },
    },
  },

  statuses: {
    onATrip: 'Pasajeros de viaje',
    completed: 'Pasajeros completaron viajes',
    created: 'Pasajeros creados (de {{hourFrom}})',
  },

  totalPassengers: 'Total de pasajeros',
};

export default passengers;
